import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Calendar as CalIcon } from "lucide-react";

const PRESETS = [
  { key: "today", label: "Aujourd'hui" },
  { key: "yesterday", label: "Hier" },
  { key: "day-before-yesterday", label: "Avant-hier" },
  { key: "24h", label: "24h" },
  { key: "7d", label: "7 jours" },
  { key: "30d", label: "30 jours" },
  { key: "month", label: "Mois en cours" },
  { key: "year", label: "Année en cours" },
  { key: "12m", label: "12 mois" },
];

export default function DateRangePicker({ value, onChange }) {
  const { period, start_date, end_date } = value || {};
  const [customOpen, setCustomOpen] = useState(false);
  const [from, setFrom] = useState(start_date || "");
  const [to, setTo] = useState(end_date || "");

  const pick = (key) => onChange({ period: key });
  const applyCustom = () => { if (from && to) { onChange({ period: "custom", start_date: from, end_date: to }); setCustomOpen(false); } };

  return (
    <div className="space-y-2">
      <div className="flex gap-2 overflow-x-auto scrollbar-hide">
        {PRESETS.map(p => (
          <button
            key={p.key}
            type="button"
            data-testid={`period-${p.key}`}
            onClick={() => pick(p.key)}
            className={`shrink-0 h-9 px-3 rounded-lg text-xs font-semibold transition border ${
              period === p.key ? "bg-[#E65100] text-white border-[#E65100]" : "bg-white dark:bg-[#1A1918] text-[#1A1918] dark:text-[#F5F3EE] border-[#E8E6E1] dark:border-[#2E2C29]"
            }`}
          >
            {p.label}
          </button>
        ))}
        <button
          type="button"
          data-testid="period-custom"
          onClick={() => setCustomOpen(o => !o)}
          className={`shrink-0 h-9 px-3 rounded-lg text-xs font-semibold transition border inline-flex items-center gap-1 ${
            period === "custom" ? "bg-[#E65100] text-white border-[#E65100]" : "bg-white dark:bg-[#1A1918] text-[#1A1918] dark:text-[#F5F3EE] border-[#E8E6E1] dark:border-[#2E2C29]"
          }`}
        >
          <CalIcon className="h-3.5 w-3.5" /> Personnalisée
        </button>
      </div>
      {customOpen && (
        <div className="p-3 rounded-xl bg-white dark:bg-[#1A1918] border border-[#E8E6E1] dark:border-[#2E2C29] space-y-2">
          <div className="grid grid-cols-2 gap-2">
            <div>
              <Label className="text-xs">Date de début</Label>
              <Input data-testid="range-from" type="date" className="h-10 rounded-lg mt-1" value={from} onChange={(e) => setFrom(e.target.value)} />
            </div>
            <div>
              <Label className="text-xs">Date de fin</Label>
              <Input data-testid="range-to" type="date" className="h-10 rounded-lg mt-1" value={to} onChange={(e) => setTo(e.target.value)} />
            </div>
          </div>
          <Button data-testid="range-apply" onClick={applyCustom} disabled={!from || !to} className="w-full h-10 rounded-lg bg-[#E65100] hover:bg-[#C44100]">Appliquer</Button>
        </div>
      )}
    </div>
  );
}
